import { z } from 'zod';

import { PAGINATION } from '~/constants';

export const adviserListSearchSchema = z.object({
    page: z.number().int().positive().optional().default(PAGINATION.DEFAULT_PAGE).catch(PAGINATION.DEFAULT_PAGE),
    pageSize: z
        .number()
        .refine((pageSize) => PAGINATION.ADVISER_LIST.PAGE_SIZE_OPTIONS.includes(pageSize))
        .optional()
        .default(PAGINATION.ADVISER_LIST.DEFAULT_PAGE_SIZE)
        .catch(PAGINATION.ADVISER_LIST.DEFAULT_PAGE_SIZE),
});

export type AdviserListSearchSchema = z.infer<typeof adviserListSearchSchema>;
